import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  Filler
);

const LineChartWithPoint = (prop) => {
  const tickFontSize = prop?.tickFontSize;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        display: true,
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: true,
          offset: false,
        },
        ticks: {
          align: "center",
          ...(tickFontSize ? { font: { size: tickFontSize } } : {}),
        },
      },
      y: {
        display: true,
        grid: {
          display: false,
        },
        ticks: {
          ...(tickFontSize ? { font: { size: tickFontSize } } : {}),
        },
      },
    },
  };


  const labels =
    prop?.data && prop?.data["Chart Label"]
      ? prop?.data["Chart Label"].split(",")?.length > 1
        ? prop?.data["Chart Label"].split(",")
        : ["", ...prop?.data["Chart Label"].split(",")]
      : [0, 0, 0, 0, 0];

  const metricColorMap = {
    "CPU Usage": {
      borderColor: " #75BDE7",
      backgroundColor: "rgba(117, 189, 231, 0.2)",
    },
    "Memory Usage": {
      borderColor: " #BC6CD4",
      backgroundColor: "rgba(188, 108, 212, 0.2)",
    },
    "Network Usage": {
      borderColor: " #D89965",
      backgroundColor: "rgba(216, 153, 101, 0.2)",
    },
  };

  const buildDataset = (metricName) => ({
    label: metricName,
    data:
      prop?.data && prop?.data[metricName]
        ? prop?.data[metricName]?.split(",")?.length > 1
          ? prop?.data[metricName]?.split(",")
          : [0, ...prop?.data[metricName]?.split(",")]
        : [0, 0, 0, 0, 0],
    borderColor: metricColorMap[metricName]?.borderColor,
    backgroundColor: metricColorMap[metricName]?.backgroundColor,
    fill: true,
    tension: 0.4,
    pointRadius: 0,
  });

  const datasets = prop?.params
    ? [buildDataset(prop.params)]
    : [
      buildDataset("CPU Usage"),
      buildDataset("Memory Usage"),
      buildDataset("Network Usage"),
    ];

  const data = {
    labels,
    datasets,
  };

  return <Line data={data} options={options} />;
};

export default LineChartWithPoint;
